export class UF {
  ID_UF: string;
  NM_NOME: string;
  NM_SIGLA: string;

  /**
   * Usar o parâmetro opcional para receber um objeto das APIs
   * @param obj
   */
  constructor(obj?: any) {
    if (obj) {
      this.ID_UF = obj.ID_UF;
      this.NM_NOME = obj.NM_NOME;
      this.NM_SIGLA = obj.NM_SIGLA;
    }
  }
}
